import React from 'react';
import { apps } from '../data/apps';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Spiegelei Studio</h3>
            <p>Apps and browser extensions for learning languages, chess, and travel.</p>
          </div>

          <div className="footer-section">
            <h4>Apps</h4>
            <ul>
              {apps.map((app) => (
                <li key={app.id}>
                  {app.websiteUrl ? (
                    <a href={app.websiteUrl} target="_blank" rel="noopener noreferrer">{app.title}</a>
                  ) : (
                    <a href="/#apps">{app.title}</a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h4>Information</h4>
            <ul>
              <li><a href="/#billing">Pricing &amp; Billing</a></li>
              <li><a href="/terms">Terms of Sale</a></li>
              <li><a href="/refund">Refund Policy</a></li>
              <li><a href="/privacy">Privacy Policy</a></li>
              <li><a href="/imprint">Imprint</a></li>
              <li><a href="mailto:service@spiegeleistudio.com">Contact</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Impressum</h4>
            <div className="impressum-info">
              <p>Spiegelei Studio</p>
              <p>(Inh. Bing Xia)</p>
              <p>Hedwig-Wachenheim-Karree 142</p>
              <p>51107 Köln, Germany</p>
              <p><a href="mailto:service@spiegeleistudio.com">service@spiegeleistudio.com</a></p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Spiegelei Studio. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
